/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
import API from "../API";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const useWhoAmI = () => {
    const [currentUser, setCurrentUser] = useState();
    let location = useLocation();

    useEffect(() => {
        if (location.pathname !== '/' && location.pathname !== '/login') {
            whosMe();
        }
    }, []);

    async function whosMe() {
        const res = await API.get('whoAmI');
        let data = res.data.data;
        if (res.data.status === 'success') {
            setCurrentUser(data);
        }
    }

    return [
        currentUser,
        setCurrentUser
    ]
}

export default useWhoAmI;